var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeDropper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3,6.24l2.12-2.12c.39-.39,.39-1.03,0-1.42L15.3,.58c-.39-.39-1.03-.39-1.42,0l-.15,.16-1.98,1.98-.83,.82-1.41-1.41c-.19-.19-.45-.29-.71-.29s-.52,.1-.71,.29c-.39,.39-.39,1.02,0,1.41l.69,.69L0,13v5H5L13.77,9.22l.69,.69c.2,.19,.45,.29,.7,.29s.52-.1,.71-.29c.39-.39,.39-1.03,0-1.42l-1.41-1.41,.82-.83h.02ZM3.58,16.58l-2.17-2.17L10.19,5.64l2.17,2.17L3.58,16.58Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeDropper);
export default __webpack_public_path__ + "static/media/eye_dropper.beacee37dbd52c8d07b26751cf7532a0.svg";
export { ForwardRef as ReactComponent };